import React, { useEffect, useState } from 'react'
import { styled } from 'linaria/react'
import { useSiteSettingsQuery } from '../../../hooks/useSiteSettings'
import { Product_Page_Settings } from '../../CustomElements/elementTypes'
import { theme } from '../../Theme'
import FilterTags from '../../CategoryPage/Filters/FilterTags'
import MobileFilterDrawer from '../../CategoryPage/Filters/MobileFilterDrawer'
import { EXPECTED_PX_HEADER_HEIGHT } from '../Util/Constants'
import SiteButton from '../SiteButton'
import { useIntl } from '@jetshop/intl'
import Pagination from '../../CategoryPage/Widgets/Pagination'
import SearchBox from '../../CategoryPage/Filters/SearchBox'
import { useDigifiProductSearch } from '../../DigifiSearch/Hooks/useDigifiProductSearch'
import FilterList from '../../CategoryPage/Filters/FilterList'
import ProductHitsGrid from './ProductHitsGrid'
import {
   DIGIFI_DEFAULT_PAGE_SIZE,
   DIGIFI_FILTER_FIELD_NAMES,
} from '../../DigifiSearch/constants'
import NextPrevPageMetaLinks from '../../CategoryPage/Widgets/NextPrevPageMetaLinks'
import FilterButtonsSkeleton from '../Skeletons/FilterButtonsSkeleton'
import useDigifiCategoryTree from '../../DigifiSearch/Hooks/useDigifiCategoryTree'
import CategoryTree from '../../CategoryPage/Widgets/CategoryTree'

const ProductListWrapper = styled.div`
   background-color: ${theme.colors.white};

   .main-container {
      background-color: ${theme.colors.white};
      padding-top: 0.5rem;

      ${theme.above.lg} {
         padding-top: 2rem;
      }
   }

   ${theme.below.lg} {
      .filter-buttons {
         margin-bottom: 0.5rem;
      }
   }

   ${theme.below.md} {
      .content-container {
         background-color: ${theme.colors.white};
         margin-left: 0px;
      }
      .filter-buttons {
         padding-right: 1rem;
         padding-left: 1rem;
      }
   }

   .product-list-wrapper {
      height: 100%;
      background-color: ${theme.colors.white};
      border-top-left-radius: 32px 32px;
      padding-right: inherit; /* Keep pr-128 */
      padding-right: 0.5rem;
      padding-left: 0.5rem;

      ${theme.above.md} {
         padding-right: 4rem;
         padding-left: 0rem;
      }
      ${theme.above.lg} {
         padding-left: 2.5rem;
      }
      ${theme.above.xl} {
         padding-left: 4rem;
      }
      ${theme.above.xxl} {
         padding-right: 8rem;
      }
   }

   .filter-tags-wrapper {
      background-color: ${theme.colors.white};
   }

   .sticky-filter-menu-desktop {
      background-color: ${theme.colors.white};
      /* position: -webkit-sticky;
      position: sticky;
      top: ${EXPECTED_PX_HEADER_HEIGHT.md};
      z-index: 99;
      max-height: calc(100vh - ${EXPECTED_PX_HEADER_HEIGHT.md});
      overflow-y: auto;
      ${theme.above.xl} {
         top: ${EXPECTED_PX_HEADER_HEIGHT.lg};
         max-height: calc(100vh - ${EXPECTED_PX_HEADER_HEIGHT.lg});
      } */
   }

   .side-panel {
      z-index: 1;
      background-color: ${theme.colors.white};
      min-width: 280px;
   }

   .category-tree-wrapper {
      /* border-top: 1px solid var(--color-separator); */
   }

   .product-results-wrapper {
      flex: 3;
   }

   .price-accordion {
      border-bottom: 1px solid var(--color-separator) !important;
      margin-bottom: 1rem;
   }

   .sticky-filter-menu-desktop .accordion-wrapper:first-child .top-separator {
      border-top: 1px solid transparent !important;
   }
`

const SingleBrandProductList = ({
   category: { id: categoryId, name: categoryName, subcategories } = {},
}) => {
   const t = useIntl()
   const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false)
   const [isMobileCategoriesOpen, setIsMobileCategoriesOpen] = useState(false)
   const [getSetting, loadingSiteSettings] = useSiteSettingsQuery()
   const productSettings = getSetting(null, Product_Page_Settings)
   const [searchValue, setSearchValue] = useState('')
   const [showSkeleton, setShowSkeleton] = useState(true)
   const { topLevelCategory, hasSubCategories } =
      useDigifiCategoryTree(categoryId)
   const {
      filters,
      products,
      facets,
      metaData,
      loading,
      errorMessage,
      updateFilters,
      resetTagFilters,
   } = useDigifiProductSearch(
      categoryId && {
         fieldName: DIGIFI_FILTER_FIELD_NAMES.BRAND_CATEGORY_ID,
         value: categoryId,
      }
   )

   useEffect(() => {
      setShowSkeleton(!categoryId)
   }, [categoryId])

   return (
      <React.Fragment>
         <NextPrevPageMetaLinks
            currentPage={metaData?.currentPage}
            totalPages={metaData?.totalPages}
         />
         <ProductListWrapper>
            <div
               id="last-page-scroll-anchor"
               className="main-container container-fluid pe-0 ps-0"
            >
               <div className="content-container d-block d-lg-flex ml-128">
                  <div
                     className={`side-panel col-lg-2 d-none d-lg-block br-8}`}
                  >
                     <div className="sticky-filter-menu-desktop pb-32">
                        <SearchBox
                           searchValue={searchValue}
                           setSearchValue={setSearchValue}
                           onSearchChange={searchValue => {
                              updateFilters([
                                 {
                                    fieldName:
                                       DIGIFI_FILTER_FIELD_NAMES.SEARCH_QUERY,
                                    value: searchValue,
                                 },
                              ])
                           }}
                           placeholder={t('Search in {categoryName}', {
                              categoryName: categoryName ?? '',
                           })}
                        />
                        <div className="primary-shadow px-16 br-8 pb-32">
                           {subcategories?.length > 0 && hasSubCategories && (
                              <div className="category-tree-wrapper">
                                 <CategoryTree
                                    rootCategoryTitle={t('categories')}
                                    category={topLevelCategory}
                                    selectedCategoryId={categoryId}
                                    isRootLevelComp={true}
                                    initiallyExpanded={true}
                                    hideLevel2Sibblings={true}
                                 />
                              </div>
                           )}
                           <FilterList
                              filters={filters}
                              facets={facets}
                              updateFilters={updateFilters}
                              hideFilters={[DIGIFI_FILTER_FIELD_NAMES.BRAND]}
                           />
                        </div>
                     </div>
                  </div>

                  <div className="product-results-wrapper">
                     <div className="filter-tags-wrapper">
                        <div className="d-block d-lg-none">
                           {showSkeleton ? (
                              <FilterButtonsSkeleton />
                           ) : (
                              <div className="filter-buttons d-flex gap-2 py-8 pr-128">
                                 {subcategories?.length > 0 &&
                                    hasSubCategories && (
                                       <SiteButton
                                          size="medium"
                                          onClick={() =>
                                             setIsMobileCategoriesOpen(
                                                prev => !prev
                                             )
                                          }
                                          styleType="solid"
                                          color={'blue'}
                                          className="w-100"
                                          style={{
                                             paddingTop: '10px',
                                             paddingBottom: '10px',
                                          }}
                                       >
                                          {t('categories')}
                                       </SiteButton>
                                    )}
                                 <SiteButton
                                    size="medium"
                                    onClick={() =>
                                       setIsMobileFilterOpen(prev => !prev)
                                    }
                                    styleType="solid"
                                    color={'blue'}
                                    className="w-100"
                                    style={{
                                       paddingTop: '10px',
                                       paddingBottom: '10px',
                                    }}
                                 >
                                    Filter
                                 </SiteButton>
                              </div>
                           )}
                        </div>
                        <FilterTags
                           filters={filters}
                           visibleFilterTagsByFieldName={[
                              DIGIFI_FILTER_FIELD_NAMES.PRICE,
                              DIGIFI_FILTER_FIELD_NAMES.PREBOOK,
                              DIGIFI_FILTER_FIELD_NAMES.SORT_BY,
                           ]}
                           updateFilters={updateFilters}
                           onClearFilters={() => {
                              resetTagFilters({
                                 filtersByFieldNameToPreserve: [
                                    // 'categories',
                                 ],
                              })
                              setSearchValue('')
                           }}
                        />
                     </div>

                     <div className="product-list-wrapper pb-32 pr-128">
                        <ProductHitsGrid
                           products={products}
                           productSettings={productSettings}
                           loading={loading}
                           loadingCardsCount={DIGIFI_DEFAULT_PAGE_SIZE}
                        />
                        <div className="w-100 d-flex justify-content-center pt-32">
                           <Pagination
                              metaData={metaData}
                              updateFilters={updateFilters}
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div className="d-block d-lg-none">
               <MobileFilterDrawer
                  title={'Filter'}
                  isOpen={isMobileFilterOpen}
                  setIsOpen={setIsMobileFilterOpen}
               >
                  <SearchBox
                     topSpace={true}
                     searchValue={searchValue}
                     setSearchValue={setSearchValue}
                     onSearchChange={searchValue => {
                        updateFilters([
                           {
                              fieldName: DIGIFI_FILTER_FIELD_NAMES.SEARCH_QUERY,
                              value: searchValue,
                           },
                        ])
                     }}
                     placeholder={t('Search in {categoryName}', {
                        categoryName: categoryName ?? '',
                     })}
                  />
                  <FilterList
                     filters={filters}
                     facets={facets}
                     updateFilters={updateFilters}
                     hideFilters={[DIGIFI_FILTER_FIELD_NAMES.BRAND]}
                  />
               </MobileFilterDrawer>
            </div>

            <div className="d-block d-lg-none">
               {subcategories?.length > 0 && hasSubCategories && (
                  <MobileFilterDrawer
                     title={t('categories')}
                     isOpen={isMobileCategoriesOpen}
                     setIsOpen={setIsMobileCategoriesOpen}
                  >
                     <CategoryTree
                        rootCategoryTitle={t('categories')}
                        category={topLevelCategory}
                        selectedCategoryId={categoryId}
                        isRootLevelComp={true}
                        initiallyExpanded={true}
                        hideLevel2Sibblings={true}
                     />
                  </MobileFilterDrawer>
               )}
            </div>
         </ProductListWrapper>
      </React.Fragment>
   )
}
export default SingleBrandProductList
